import { render, staticRenderFns } from "./CodingRequestAcuteCoderDetails.vue?vue&type=template&id=23cfa98c&scoped=true&"
import script from "./CodingRequestAcuteCoderDetails.vue?vue&type=script&lang=js&"
export * from "./CodingRequestAcuteCoderDetails.vue?vue&type=script&lang=js&"
import style0 from "./CodingRequestAcuteCoderDetails.vue?vue&type=style&index=0&id=23cfa98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cfa98c",
  null
  
)

export default component.exports